// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export * from './TermsOfUse';
export { type TermsOfUseProps } from './TermsOfUse.types';
